// @flow
import React from 'react';
import styled from 'styled-components';
import { FlexColumn, FlexRow } from 'styles/Layout';
import { IconImg, InfoTitle } from 'modules/agencies/shared/style/BaseTemplate';
import { AdvisorAssets } from 'utils/ExportCommon';
import { SubmitButton } from 'modules/agencies/shared/style/BaseTemplate';

const SectionContainer = styled(FlexColumn)`
  margin-bottom: 10px;
`;

const ContentActions = styled.div`
  margin-top: 50px;
  width: 320px;
`;

const StyledInfoTitle = styled(InfoTitle)`
  cursor: pointer;
`;

const StyledSubmitButton = styled(SubmitButton)`
  cursor: pointer;
`;

type PropsType = {
  buttonFunction?: () => void,
  linkFunction?: () => void,
  showButtonFunction?: boolean,
  showlinkFunction?: boolean,
  principalTitle?: string,
  subTitle?: string,
  submitButtonTitle?: string,
  linkTitle?: string,
  classes?: any
};

export default class SuccessFinalProcess extends React.Component<PropsType> {
  renderInfoTiTle = () => {
    const { showlinkFunction, linkTitle } = this.props;
    return showlinkFunction ? (
      <StyledInfoTitle
        fontSize="16px"
        marginTop="20px"
        marginBottom="0px"
        marginRight="20px"
        isCenter={''}
        isBold={'bold'}
        onClick={this.linkFunction}
      >
        {linkTitle}
      </StyledInfoTitle>
    ) : null;
  };

  buttonFunction = (): void => {
    this.props.buttonFunction();
  };

  linkFunction = (): void => {
    this.props.linkFunction();
  };

  renderSubmitButton = () => {
    const { showButtonFunction, submitButtonTitle } = this.props;
    return showButtonFunction ? (
      <StyledSubmitButton onClick={this.buttonFunction}>
        {submitButtonTitle}
      </StyledSubmitButton>
    ) : null;
  };

  render() {
    const { principalTitle, subTitle, classes } = this.props;
    return (
      <div>
        <SectionContainer>
          <IconImg
            className={classes ? classes : null}
            width="120px"
            height="120px"
            marginTop="90px"
            marginBottom="60px"
            src={AdvisorAssets.SuccessProcessDarkGray}
          />
          <div
            style={{
              width: classes ? '100%' : '140px',
              display: 'block',
              marginLeft: classes ? 'none' : 'auto',
              marginRight: classes ? 'none' : 'auto',
              textAlign: 'center'
            }}
          >
            <InfoTitle
              fontSize="25px"
              marginTop="0px"
              marginBottom="20px"
              isCenter={'center'}
              isBold={'bold'}
            >
              {principalTitle}
            </InfoTitle>
            <InfoTitle
              fontSize="20px"
              marginTop="0px"
              marginBottom="0px"
              isCenter={'center'}
              isBold={'normal'}
            >
              {subTitle}
            </InfoTitle>
          </div>
        </SectionContainer>
        <ContentActions>
          <FlexRow justifyContent="flex-end">
            {this.renderInfoTiTle()}
            {this.renderSubmitButton()}
          </FlexRow>
        </ContentActions>
      </div>
    );
  }
}
